import { render, staticRenderFns } from "./StockManagement.vue?vue&type=template&id=17228756&scoped=true"
import script from "./StockManagement.vue?vue&type=script&lang=js"
export * from "./StockManagement.vue?vue&type=script&lang=js"
import style0 from "./StockManagement.vue?vue&type=style&index=0&id=17228756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17228756",
  null
  
)

export default component.exports